import React from "react";
import Newsletter from "./form/Newsletter";
import logo from "../assests/logo.png";
import {SchedulePostFooter} from "./btn/SchedulePost";

const Footer = () => {
  return (
    <footer className="bg-textPrimary text-white pt-16">
      <div className="container mx-auto">
        {/* First Row: Newsletter Section */}
        <Newsletter />

        {/* Schedule Post Btn */}
        {/* <SchedulePostFooter /> */}

        {/* Second Row: Footer Columns */}
        <div className="bg-textPrimary py-8 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 md:gap-36 text-center md:text-left">
            <div className="space-y-4">
              {/* Logo */}
              <div className="font-bold">
                <a href="/">
                  <img
                    src={logo}
                    alt="MyLogo"
                    className="mx-auto md:mx-0 h-8 sm:h-10 md:h-12 lg:h-8"
                  />
                </a>
              </div>

              {/* <div>
                <p className="mb-2 text-lg font-semibold">
                  Lorem ipsum dolor sit amet
                </p>
                <ul className="flex items-center justify-center md:justify-start gap-2">
                  <li>
                    <a href="/#" target="_blank" className="hover:text-primary">
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_6269_1553)">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M24 22.9366C24 23.6682 23.4068 24.2612 22.6754 24.2612L16.6101 24.2612V14.9558H19.7943L20.271 11.3294H16.6101V9.01398C16.6101 7.96402 16.9074 7.2485 18.4423 7.2485L20.4 7.24765V4.00419C20.0613 3.95998 18.8992 3.86123 17.5473 3.86123C14.7247 3.86123 12.7924 5.55125 12.7924 8.65495V11.3294H9.6V14.9558H12.7924V24.2612L1.32459 24.2612C0.592875 24.2612 0 23.6682 0 22.9366V1.58582C0 0.854197 0.592875 0.26123 1.32459 0.26123H22.6754C23.4068 0.26123 24 0.854197 24 1.58582V22.9366Z"
                            fill="#919191"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_6269_1553">
                            <rect
                              y="0.26123"
                              width="24"
                              height="24"
                              rx="7"
                              fill="white"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a href="/#" target="_blank" className="hover:text-primary">
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M23.4975 6.49725C23.3616 5.98856 23.0969 5.52801 22.7316 5.16458C22.3559 4.78996 21.8955 4.52199 21.3937 4.38596C19.516 3.86653 11.993 3.86653 11.993 3.86653C8.85676 3.82908 5.72128 3.99379 2.60427 4.35973C2.10252 4.50581 1.64296 4.77977 1.26645 5.15723C0.896497 5.5308 0.628533 5.99146 0.488551 6.4962C0.15229 8.39735 -0.0110893 10.3277 0.0006171 12.2613C-0.0113813 14.1932 0.151597 16.1229 0.488551 18.0264C0.625533 18.5291 0.892497 18.9876 1.26345 19.3581C1.6344 19.7285 2.09634 19.9961 2.60427 20.1377C4.50701 20.6561 11.993 20.6561 11.993 20.6561C15.1332 20.6936 18.2727 20.5289 21.3937 20.1629C21.8955 20.0269 22.3559 19.7589 22.7316 19.3843C23.1015 19.0139 23.3645 18.5532 23.4965 18.0516C23.8415 16.1512 24.0093 14.22 23.9974 12.2855C24.0233 10.3427 23.8558 8.40241 23.4975 6.4962V6.49725ZM9.60133 15.8543V8.6694L15.8605 12.2624L9.60133 15.8543Z"
                          fill="#919191"
                        />
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a href="/#" target="_blank" className="hover:text-primary">
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_6269_1558)">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M17.4988 14.6432C17.1994 14.4942 15.7313 13.7762 15.458 13.6762C15.1847 13.5772 14.9858 13.5282 14.7858 13.8262C14.5869 14.1222 14.0151 14.7922 13.8413 14.9902C13.6665 15.1892 13.4926 15.2132 13.1942 15.0652C12.8958 14.9152 11.9332 14.6022 10.7927 13.5903C9.90544 12.8023 9.30557 11.8293 9.13173 11.5313C8.9579 11.2343 9.11264 11.0733 9.26236 10.9253C9.39701 10.7923 9.56079 10.5783 9.71051 10.4053C9.86022 10.2313 9.90946 10.1073 10.0089 9.90826C10.1094 9.71026 10.0592 9.53726 9.98382 9.38826C9.90946 9.23926 9.3126 7.77626 9.06341 7.18126C8.82125 6.60226 8.57507 6.68126 8.39219 6.67126C8.21736 6.66326 8.0184 6.66126 7.81945 6.66126C7.6205 6.66126 7.29695 6.73526 7.02364 7.03326C6.74932 7.33026 5.97863 8.04926 5.97863 9.51226C5.97863 10.9743 7.04775 12.3873 7.19747 12.5863C7.34719 12.7843 9.30255 15.7862 12.2979 17.0732C13.0113 17.3792 13.567 17.5622 14.0001 17.6982C14.7155 17.9252 15.3666 17.8932 15.8811 17.8162C16.4538 17.7312 17.6475 17.0972 17.8967 16.4032C18.1449 15.7092 18.1449 15.1142 18.0705 14.9902C17.9962 14.8662 17.7972 14.7922 17.4978 14.6432H17.4988ZM12.0507 22.0462H12.0467C10.2676 22.0466 8.52118 21.5706 6.99048 20.6682L6.62875 20.4542L2.86874 21.4362L3.87255 17.7882L3.63642 17.4142C2.64179 15.8386 2.11543 14.015 2.11814 12.1543C2.12015 6.70426 6.57549 2.27027 12.0547 2.27027C14.7074 2.27027 17.2014 3.30027 19.0764 5.16826C20.0012 6.08484 20.7342 7.17483 21.233 8.37516C21.7318 9.57549 21.9864 10.8623 21.9823 12.1613C21.9803 17.6112 17.5249 22.0462 12.0507 22.0462ZM20.5032 3.74927C19.3961 2.64019 18.0788 1.76081 16.6277 1.16207C15.1766 0.563335 13.6206 0.257154 12.0497 0.261271C5.46417 0.261271 0.102491 5.59626 0.100481 12.1533C0.0994764 14.2492 0.649109 16.2952 1.69512 18.0982L0 24.2612L6.33434 22.6072C8.0866 23.5574 10.0502 24.0552 12.0457 24.0552H12.0507C18.6363 24.0552 23.9979 18.7202 23.9999 12.1623C24.0048 10.5995 23.6983 9.05136 23.0981 7.60729C22.4978 6.16323 21.6159 4.85193 20.5032 3.74927Z"
                            fill="#919191"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_6269_1558">
                            <rect
                              width="24"
                              height="24"
                              fill="white"
                              transform="translate(0 0.26123)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </a>
                  </li>
                  <li>
                    <a href="/#" target="_blank" className="hover:text-primary">
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_6269_1560)">
                          <path
                            d="M12 0.26123C15.2604 0.26123 15.6672 0.27323 16.9464 0.33323C18.2244 0.39323 19.0944 0.593631 19.86 0.891231C20.652 1.19603 21.3192 1.60883 21.9864 2.27483C22.5966 2.87471 23.0687 3.60034 23.37 4.40123C23.6664 5.16563 23.868 6.03683 23.928 7.31483C23.9844 8.59403 24 9.00083 24 12.2612C24 15.5216 23.988 15.9284 23.928 17.2076C23.868 18.4856 23.6664 19.3556 23.37 20.1212C23.0696 20.9226 22.5973 21.6484 21.9864 22.2476C21.3864 22.8576 20.6608 23.3297 19.86 23.6312C19.0956 23.9276 18.2244 24.1292 16.9464 24.1892C15.6672 24.2456 15.2604 24.2612 12 24.2612C8.7396 24.2612 8.3328 24.2492 7.0536 24.1892C5.7756 24.1292 4.9056 23.9276 4.14 23.6312C3.33879 23.3306 2.61303 22.8584 2.0136 22.2476C1.40329 21.6479 0.931118 20.9222 0.63 20.1212C0.3324 19.3568 0.132 18.4856 0.0719999 17.2076C0.0155999 15.9284 0 15.5216 0 12.2612C0 9.00083 0.0119999 8.59403 0.0719999 7.31483C0.132 6.03563 0.3324 5.16683 0.63 4.40123C0.930283 3.59985 1.40256 2.87402 2.0136 2.27483C2.61321 1.66431 3.33891 1.19211 4.14 0.891231C4.9056 0.593631 5.7744 0.39323 7.0536 0.33323C8.3328 0.27683 8.7396 0.26123 12 0.26123ZM12 6.26123C10.4087 6.26123 8.88258 6.89337 7.75736 8.01859C6.63214 9.14381 6 10.6699 6 12.2612C6 13.8525 6.63214 15.3787 7.75736 16.5039C8.88258 17.6291 10.4087 18.2612 12 18.2612C13.5913 18.2612 15.1174 17.6291 16.2426 16.5039C17.3679 15.3787 18 13.8525 18 12.2612C18 10.6699 17.3679 9.14381 16.2426 8.01859C15.1174 6.89337 13.5913 6.26123 12 6.26123ZM19.8 5.96123C19.8 5.56341 19.642 5.18188 19.3607 4.90057C19.0794 4.61927 18.6978 4.46123 18.3 4.46123C17.9022 4.46123 17.5206 4.61927 17.2393 4.90057C16.958 5.18188 16.8 5.56341 16.8 5.96123C16.8 6.35906 16.958 6.74059 17.2393 7.02189C17.5206 7.3032 17.9022 7.46123 18.3 7.46123C18.6978 7.46123 19.0794 7.3032 19.3607 7.02189C19.642 6.74059 19.8 6.35906 19.8 5.96123ZM12 8.66123C12.9548 8.66123 13.8705 9.04051 14.5456 9.71565C15.2207 10.3908 15.6 11.3065 15.6 12.2612C15.6 13.216 15.2207 14.1317 14.5456 14.8068C13.8705 15.4819 12.9548 15.8612 12 15.8612C11.0452 15.8612 10.1295 15.4819 9.45442 14.8068C8.77928 14.1317 8.4 13.216 8.4 12.2612C8.4 11.3065 8.77928 10.3908 9.45442 9.71565C10.1295 9.04051 11.0452 8.66123 12 8.66123Z"
                            fill="#919191"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_6269_1560">
                            <rect
                              width="24"
                              height="24"
                              fill="white"
                              transform="translate(0 0.26123)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </a>
                  </li>
                </ul>
              </div> */}
            </div>
            <div className="space-y-4">
              <h3 className="text-lg font-semibold">Lumor Studio</h3>
              <ul className="grid gap-4">
                <li>
                  <p>548 Market St</p>
                  <p>San Francisco</p>
                  <p>PMB 713021</p>
                  <p>CA 94104</p>
                  <p className="hover:text-primary poppins">(415) 310-9578</p>
                </li>
                <li>
                  <p className="hover:text-primary poppins">
                    hello@lumor.studio
                  </p>
                </li>
              </ul>
            </div>
            {/* <div className="space-y-4">
              <h3 className="text-lg font-semibold">Lorem ipsum dolor</h3>
              <ul>
                <li>
                  <p className="hover:text-primary poppins">Lorem ipsum</p>
                </li>
                <li>
                  <p className="hover:text-primary poppins">Lorem ipsum</p>
                </li>
                <li>
                  <p className="hover:text-primary poppins">Lorem ipsum</p>
                </li>
                <li>
                  <p className="hover:text-primary poppins">Lorem ipsum</p>
                </li>
              </ul>
            </div> */}
          </div>
        </div>
        {/* Third Row: Copyright Section */}
        <div className="bg-textPrimary py-4 pb-8 border-t border-boderLight border-opacity-15">
          <div className="container mx-auto text-center">
            <p className="text-sm text-white poppins">
              Copyright©2024 | All rights reserved. | Lumor Studio
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
